define.alias("shared/modifiers/on-escape-key-up", "calendar/modifiers/on-escape-key-up");